// @flow
import * as OutlinedButton from './outlined'

// Types
import type { Props } from './general'

export const StyledButton = (props: Props) => ({
  ...OutlinedButton.StyledButton(props),
  border: '1px solid transparent',
})
